import { Form, Input, Button, Alert } from 'antd';
import { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuthWrapper } from '_helpers';

export { ResetPassword };

function ResetPassword() {
    const authWrapper = useAuthWrapper();
    const location = useLocation();
    const history = useHistory();
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();

    const token = new URLSearchParams(location.search).get('token');

    const onFinish = async (values) => {
        setSubmitting(true);
        const result = await authWrapper.resetPassword({ token, password: values.password });
        setSubmitting(false);

        if (result.status === 'Success') {
            setTimeout(() => history.push('/account/login'), 2000);
        }
    };

    if (!token) {
        return (
            <div className="account-screen">
                <div className="account-card">
                    <Alert message="Lỗi" description="Liên kết không hợp lệ hoặc đã hết hạn" type="error" />
                    <div style={{ marginTop: 16 }}>
                        <Button type="primary" href="/account/login">Quay lại đăng nhập</Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="account-screen">
            <div className="account-card">
                <h4 style={{ marginBottom: 24 }}>Đặt lại mật khẩu</h4>
                <Form layout="vertical" onFinish={onFinish} form={form}>
                    <Form.Item
                        label="Mật khẩu mới"
                        name="password"
                        rules={[
                            { required: true, message: 'Vui lòng nhập mật khẩu' },
                            { min: 8, message: 'Mật khẩu phải có ít nhất 8 ký tự' }
                        ]}
                    >
                        <Input.Password size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Xác nhận mật khẩu"
                        name="confirmPassword"
                        rules={[
                            { required: true, message: 'Vui lòng xác nhận mật khẩu' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Mật khẩu xác nhận không trùng khớp'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password size="large" />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" loading={submitting} size="large">
                            Đặt lại mật khẩu
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
